module.exports = __webpack_public_path__ + "img/logo-dghno-icon.ed9d57c8.svg";